import { useLocation } from 'react-router-dom';

import { useAuthenticatedContext } from 'hooks/useAuthenticated';
import { COMPANY } from 'models/company.model';
import AccessDenied from 'pages/AccessDenied';

type Props = {
  children: React.ReactElement;
  restrictedTo?: COMPANY[];
};

const RouteProtection = ({ children, restrictedTo }: Props) => {
  const { currentUser } = useAuthenticatedContext();
  const location = useLocation();

  if (currentUser === null && restrictedTo) {
    return <AccessDenied />;
  }

  if (currentUser !== null && location.pathname === '/login') {
    return <AccessDenied />;
  }

  if (currentUser !== null && !restrictedTo?.includes(currentUser.company)) {
    return <AccessDenied />;
  }

  return children;
};

export default RouteProtection;
